export const PORT_MAP = new WeakMap();
